export default "__VITE_ASSET__WvGR5pfJ__"